import type { TourProps } from "antd";
import { useMemo } from "react";
import type { TourStepConfig } from "../types";

export function useTourTargets(steps: TourStepConfig[]): NonNullable<TourProps["steps"]> {
  return useMemo(
    () =>
      steps.map(({ tourTargetId, ...rest }) => ({
        ...rest,
        target: tourTargetId
          ? ((() =>
              document.querySelector<HTMLElement>(
                `[data-tour-id="${tourTargetId}"]`,
              )) as () => HTMLElement)
          : null,
      })),
    [steps],
  );
}
